import { Breadcrumb, Container } from "react-bootstrap";
import React from "react";
import home from "../../assets/images/homelink.svg";
import { useNavigate } from "react-router-dom";

function BreadcrumbsNav({ pageNav }) {
  const navigate = useNavigate();
  return (
    <Container
      fluid={true}
      className="p-0 main-top-section d-flex justify-content-between"
    >
      <Breadcrumb className="align-items-center d-flex h-100 bread-crumb-main">
        <Breadcrumb.Item
          onClick={() => navigate("/dashboard")}
          className="align-items-center d-flex"
        >
          <img src={home} alt="home" onClick={() => navigate("/dashboard")} />
          {/* <i className="fa-regular fa-house"> </i> */}
        </Breadcrumb.Item>
        {pageNav &&
          pageNav?.map((page_item, index) => {
            return (
              <Breadcrumb.Item
                key={index}
                active={page_item.active}
                onClick={() => navigate(page_item.link)}
                className="align-items-center d-flex text-capitalize "
              >
                {"| "}
                {page_item.active ? (
                  <p className="ps-1">{page_item.name}</p>
                ) : (
                  <span
                    className="text-capitalize cursor-pointer"
                    onClick={() => navigate(page_item.link)}
                  >
                    {page_item.name}
                  </span>
                )}
              </Breadcrumb.Item>
            );
          })}
      </Breadcrumb>
    </Container>
  );
}

export default BreadcrumbsNav;
